import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';

interface OpPlusCampaignModal extends HTMLElement {
  visible?: boolean;
}

const OpPlusCampaignModal = createWrapper<OpPlusCampaignModal>('op-plus-campaign-modal');

export default OpPlusCampaignModal;
